import req from 'utils/req';
import { reqWithABTest } from 'utils/abTesting';
import { getExperimentByName } from 'utils/abTests';

const seasonalPricing = getExperimentByName('italianCitiesPricing');

export default {
  getById: (id, lang) => reqWithABTest(req(`${URL_API_HOST}/api/v2/experience/suggestions/${id}?lang=${lang}`).get, seasonalPricing.id, seasonalPricing.variants.length)(),
  getByIdInSameCategory: (id, lang) => reqWithABTest(req(`${URL_API_HOST}/api/v2/experience/same-category/${id}?lang=${lang}`).get, seasonalPricing.id, seasonalPricing.variants.length)(),
  getByIdBySameHostOrInSameCategory: (id, lang) => reqWithABTest(req(`${URL_API_HOST}/api/v2/experience/same-host-or-category/${id}?lang=${lang}`).get, seasonalPricing.id, seasonalPricing.variants.length)(),
};
